// import { io } from "socket.io-client";
// const socket = io(`${process.env.REACT_APP_API_BASE_URL}`);
// export default socket;

import { io } from "socket.io-client";
const socket = io(`${process.env.REACT_APP_API_BASE_URL}`, {
  //   autoConnect: true,
  // path: "/ws",
  transports: ["websocket", "polling"],
  reconnection: true,
  // reconnectionAttempts: 5,
  // reconnectionDelay: 2000,
});
export default socket;
